<template>
  <div
    class="crm-box salesforce"
    title="Salesforce"
    v-if="!loading"
    @click="addToSalesForce"
    @mouseover="salesforceTooltip = true"
    @mouseleave="salesforceTooltip = false"
  >
    <img src="@/assets/icons/png/crm/Salesforce.png" />
  </div>
  <spinner v-else />
</template>

<script>
import { get } from '@/assets/util/rest.js'
import { openSalesForce } from '@/assets/util/commonUtil'
import shareFunction from '@/assets/util/functions'
import {
  MX_SF_EXPORT_COMPLETE,
  MxEvent
} from '@/assets/util/constants/analytics.js'
import Spinner from '@/components/Spinner'

export default {
  name: 'AddToSalesForce',
  props: [
    'userEmail',
    'contactId',
    'trigger',
    'showUpgradePopup',
    'pageType',
    'showActivationPopup'
  ],
  data: function() {
    return {
      loading: false,
      salesforceLoginTry: false,
      salesforceTooltip: false,
      listName: this.$store.state.linkedin.list.selectedList
    }
  },
  watch: {
    trigger: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.addToSalesForce()
        }
      }
    }
  },
  components: {
    Spinner: Spinner
  },
  computed: {
    isAccountVerified: function() {
      return this.$store.state.header.emailStatus == 0
    }
  },
  methods: {
    addToSalesForce() {
      if (!this.isAccountVerified) {
        this.showActivationPopup()
      } else {
        shareFunction.track(
          MxEvent.crmRedirect,
          { exportType: 'Salesforce', pageType: this.pageType },
          this.$store.state
        )
        let that = this
        let emailId = this.userEmail
        let contactId = this.contactId
        this.salesforceTooltip = false
        if (emailId != '') {
          this.loading = true
          get('lp/sf/exportByMCId/' + contactId + '.htm?exportType=lead')
            .then(response => {
              this.loading = false
              if (response.status == 200) {
                response.json().then(res => {
                  if (res.msg == 'Invalid Token') {
                    //show salesforce popup
                    if (!that.salesforceLoginTry) {
                      that.salesforceLoginTry = true
                      let callback = function() {
                        that.addToSalesForce()
                      }
                      openSalesForce(emailId, callback)
                    } else {
                      console.log('issue in sales force login')
                    }
                  } else if (res.isExportAllowed == false) {
                    // show upgrade popup
                    this.$parent.$emit('crmUpgradePopup', 'Salesforce')
                  } else {
                    shareFunction.track(
                      MX_SF_EXPORT_COMPLETE,
                      null,
                      this.$store.state
                    )
                    const msg = this.getCustomisedExportMsg(res)
                    shareFunction.showNotificationMsg(
                      msg,
                      2000,
                      '#ff511a',
                      '#0cd972'
                    )
                  }
                })
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.errorMsg = 'Unable to perform action at this time.'
        }
      }
    },
    getCustomisedExportMsg(responseJson) {
      const msg = responseJson.msg
      if (msg.indexOf('Duplicate') != -1) {
        return 'Lead already exists in your Salesforce'
      } else if (msg.indexOf('Successfully') != -1) {
        // close listener
        return 'Added as a lead to Salesforce!'
      }
      return msg
    }
  }
}
</script>
